import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  Atlas,
  printMissingConfigError,
  SiteConfigManager,
  StaticBlocksProvider,
  TranslationProvider,
} from '@atlas/core';
import { Label } from '@atlas/ui';

import Notifications from 'common/Notifications';
import history from 'components/Layout/history';
import GlobalMaintenanceContainer from 'components/MaintenanceContainer/GlobalMaintenanceContainer';
import IFrameRoutes from 'iframe/IFrameRoutes';
import { LayoutLoader } from 'src/components/Layout/LayoutLoader';
import SelfRegulationProvider from 'src/components/SelfRegulationProvider';

// Importing and binding bus repeater
import './bus.repeater';

import { navigationTypes } from './constants';
import IFrameLayout from './IFrameLayout';

function IFrameHeaderLink(props) {
  const { name, to } = props;

  return (
    <NavLink activeClassName="active" className="chips-item header__menu__item" to={to}>
      <Label message={name} />
    </NavLink>
  );
}

IFrameHeaderLink.propTypes = {
  name: PropTypes.string,
  to: PropTypes.string,
};

const iFrameInitialState = {
  error: null,
  loading: true,
};

export default function IFrameRootLayout() {
  const showTopNavigation = SiteConfigManager.getConfig(
    'config.config.sportsbook.showTopNavigationDesktop',
    false,
  );
  const navigationList = SiteConfigManager.getConfig('config.pages', []).filter(
    ({ isActive, type }) => isActive && navigationTypes[type],
  );

  if (navigationList.length === 0) {
    printMissingConfigError('config.pages');
  }

  return (
    <Atlas>
      <TranslationProvider>
        <GlobalMaintenanceContainer>
          <StaticBlocksProvider>
            <LayoutLoader>
              <SelfRegulationProvider>
                <IFrameLayout history={history}>
                  {showTopNavigation && (
                    <div className="viewport-header bets betslip-filter">
                      {navigationList.map(({ path, type }) => (
                        <IFrameHeaderLink key={type} name={navigationTypes[type]} to={path} />
                      ))}
                    </div>
                  )}
                  <IFrameRoutes />
                </IFrameLayout>
              </SelfRegulationProvider>
            </LayoutLoader>
          </StaticBlocksProvider>
        </GlobalMaintenanceContainer>
        <Notifications />
      </TranslationProvider>
    </Atlas>
  );
}
